<template>
  <i-form label-position="top" :model="formData" :rules="ruleValidate" ref="form">
    <Row :gutter="0" type="flex" justify="center">
      <Col :span="6">
        <div class="headimg">
          <avatar
            style="display:block"
            shape="square"
            size="large"
            :src="formData.photo? formData.photo: buildingImg"
          />
          <upload
            ref="upload"
            :show-upload-list="false"
            :on-success="uploadFileSuccess"
            :on-progress="onUploading"
            :headers="token"
            :action="uploadURL"
            :format="['jpg','jpeg','png']"
            :max-size="15360"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
          >
            <i-button style="width:96px;margin-top:10px" type="primary">上传图片</i-button>
          </upload>
          <spin v-show="isLoadingByHeadImg" fix></spin>
        </div>
      </Col>
      <Col :span="18">
        <row :gutter="18">
          <i-col span="18">
            <form-item label="楼宇名称" prop="name">
              <i-input clearable v-model="formData.name" placeholder="请输入" />
            </form-item>
          </i-col>
          <i-col span="6">
            <form-item label="门牌号" prop="buildingnum">
              <InputNumber :min="0" v-model="formData.buildingnum"></InputNumber>
            </form-item>
          </i-col>
          <i-col span="24">
            <form-item label="用途" prop="natureid">
              <coding
                v-model="formData.natureid"
                coding="HouseApplication"
                type="Radio"
                v-return:name="formData.naturename"
              ></coding>
            </form-item>
          </i-col>
        </row>
      </Col>
    </Row>
  </i-form>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      refresh: true,
      buildingImg: require("../../../assets/staticsPic/morenlou.png"),
      isLoadingByHeadImg: false, //上传头像加载
      token: {
        //令牌，为上传图片使用
        token: window.localStorage.getItem("token")
      },
      uploadURL: window.location.origin + "/zuul/base/base/oss/uploadToMongo",
      formData: {
        orgid: "", //所属行政区域id
        name: "", //楼宇名称
        natureid: "", //性质ID
        naturename: "",
        photo: "",
        buildingnum: 0
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请输入楼宇名称",
            trigger: "blur"
          }
        ],
        natureid: [
          {
            required: true,
            message: "请选择楼宇性质",
            trigger: "change",
            type: "number"
          }
        ]
      }
    };
  },
  methods: {
    async save() {
      let isSucceed = false;
      try {
        let result = await this.$refs.form.validate();
        if (result) {
        //   this.formData.id = this.id;
          this.formData.orgid = 659002002005;
          
          this.formData.flag = "xxxx";
          let url = this.urlobj.bulidingSave;
          let res = await this.$post(url, this.formData);
          if (res.isSucceed) {
            this.$Message.success("保存成功");
            this.$refs.form.resetFields();
            isSucceed = res.isSucceed;
            let nowid = res.newPrimaryKeys.newPrimaryKeys;
            // this.$router.push({
            //   path: "/datacenter/geography/details/building",
            //   query: {
            //     id: nowid
            //   }
            // });
          } else {
            this.$Message.error("保存失败" + res.message);
          }
        }
      } finally {
        return isSucceed;
      }
    },
    async load() {
      this.refresh = false;
      let url = this.urlobj.getBuildingInfoById;
      let detailsRes = await this.$get(url, { id: this.id });
      this.formData = Object.assign({}, detailsRes.data.rows[0]);
      this.formData.natureid = parseInt(this.formData.natureid);
      this.$nextTick(() => (this.refresh = true));
    },
    //上传图片成功
    uploadFileSuccess(response) {
      this.formData.photo = response.rows[0].filepath;
      this.isLoadingByHeadImg = false;
    },
    //图片上传中
    onUploading() {
      this.isLoadingByHeadImg = true;
    },
    //文件格式验证失败时的钩子，返回字段为 file, fileList
    handleFormatError(file, fileList) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "[ " + file.name + " ] 文件格式不正确, 请选择 jpg 或 png"
      });
    },
    //文件超出指定大小限制时的钩子，返回字段为 file, fileList
    handleMaxSize(file, fileList) {
      this.$Notice.warning({
        title: "文件不正确",
        desc: "[ " + file.name + " ] 文件太大, 文件不能超过15M"
      });
    }
  },
  components: {
    Coding: () => import("./Coding")
  }
};
</script>

<style lang="less" scoped>
.headimg {
  width: 97px;
  position: relative;
}
.ivu-avatar-large {
  width: 96px;
  height: 96px;
  line-height: 96px;
}
</style>
